import { gql } from '@apollo/client'
import {
  BaseOfferBlock,
  BrandTabsBlockFragment,
  FeaturedOfferBlockFragment,
  FeaturedOffersBlockFragment,
  OfferCollectionBlockFragment,
  SearchBlockFragment,
} from 'app/features/offer/blocks'
import {
  FaqsBlockFragment,
  FeaturedContentCarouselBlockFragment,
  RichTextBlockFragment,
  SpacerBlockFragment,
} from 'app/features/shared/blocks'
import { usePersistedCacheQuery } from 'app/hooks'

export const fetchOfferCategoryQuery = gql`
query fetchOfferCategory($slug: String!, $draft: Boolean!) {
  OfferCategories(where: { slug: { equals: $slug } }, draft: $draft) {
    docs {
      id
      name
      slug
      content {
        ${BrandTabsBlockFragment.partialFragment}
        ${FaqsBlockFragment.partialFragment}
        ${FeaturedContentCarouselBlockFragment.partialFragment}
        ${FeaturedOfferBlockFragment.partialFragment}
        ${FeaturedOffersBlockFragment.partialFragment}
        ${OfferCollectionBlockFragment.partialFragment}
        ${RichTextBlockFragment.partialFragment}
        ${SearchBlockFragment.partialFragment}
        ${SpacerBlockFragment.partialFragment}
      }
      logo {
        url
      }
      updatedAt
      meta {
        title
        description
      }
    }
  }
}
`

export interface OfferCategoryQueryInput {
  slug: string
  draft: boolean
}

export interface OfferCategoryQueryOutput {
  OfferCategories: {
    docs: {
      id: string
      name: string
      slug: string
      content: BaseOfferBlock[]
      logo?: {
        url: string
      }
      updatedAt: string
      meta: {
        title?: string
        description?: string
      }
    }[]
  }
}

export const useOfferCategoryQuery = (input: OfferCategoryQueryInput) =>
  usePersistedCacheQuery<OfferCategoryQueryOutput, OfferCategoryQueryInput>(fetchOfferCategoryQuery, {
    variables: input,
  })
